import { MOCK_USER_TYPE } from '@monash/portal-frontend-common';
import { RadioButton, TextField } from '@monash/portal-react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import cs from '../../get-api-responses.module.scss';
import { useState } from 'react';

const MockUserFields = () => {
  const {
    setValue,
    formState: { errors },
  } = useFormContext();

  const [shouldAddMockUserFields, setShouldAddMockUserFields] = useState(false);

  const watchedMockUserType = useWatch({
    name: 'mockUserFields.mockUserType',
  });

  return (
    <div className={cs.sectionContainer}>
      <div className={cs.inputContainer}>
        <h3>Add mock user fields?</h3>
        <div>
          These are fields that are needed for production-facing mock users. Can
          omit this if you're not creating a mock user
        </div>
        <div className={cs.radioGroup}>
          <RadioButton
            label="Yes"
            onChange={() => {
              setValue('mockUserFields.mockUserType', MOCK_USER_TYPE.DEV);
              setShouldAddMockUserFields(true);
            }}
            on={shouldAddMockUserFields}
          />
          <RadioButton
            label="No"
            onChange={() => setShouldAddMockUserFields(false)}
            on={!shouldAddMockUserFields}
          />
        </div>
      </div>
      {shouldAddMockUserFields && (
        <div className={cs.inputContainer}>
          <h3>Mock user type</h3>
          <div className={cs.radioGroup}>
            <Controller
              name="mockUserFields.mockUserType"
              render={({ field: { value, onChange } }) => (
                <>
                  <RadioButton
                    label={MOCK_USER_TYPE.DEV}
                    onChange={() => onChange(MOCK_USER_TYPE.DEV)}
                    on={value === MOCK_USER_TYPE.DEV}
                  />
                  <RadioButton
                    label={MOCK_USER_TYPE.DEMO}
                    onChange={() => onChange(MOCK_USER_TYPE.DEMO)}
                    on={value === MOCK_USER_TYPE.DEMO}
                  />
                  <RadioButton
                    label={MOCK_USER_TYPE.IMPERSONATION}
                    onChange={() => onChange(MOCK_USER_TYPE.IMPERSONATION)}
                    on={value === MOCK_USER_TYPE.IMPERSONATION}
                  />
                </>
              )}
            />
          </div>
          {watchedMockUserType === MOCK_USER_TYPE.DEMO && (
            <div className={cs.inputContainer}>
              <h3>Display</h3>
              <div className={cs.sectionContainer}>
                <h4>Landing</h4>
                <div className={cs.sectionContainer}>
                  <div className={cs.inputContainer}>
                    <h5>Button label</h5>
                    <Controller
                      name="mockUserFields.display.landing.buttonLabel"
                      rules={{
                        required: 'You must provide a button label',
                      }}
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          value={value}
                          onChange={onChange}
                          placeholder="Button label"
                          error={() =>
                            errors.mockUserFields?.display?.landing?.buttonLabel
                          }
                          errorMsg={
                            errors.mockUserFields?.display?.landing?.buttonLabel
                              ?.message
                          }
                        />
                      )}
                    />
                  </div>
                  <div className={cs.inputContainer}>
                    <h5>Primary carousel label</h5>
                    <Controller
                      name="mockUserFields.display.landing.carouselLabelPrimary"
                      rules={{
                        required: 'You must provide a primary carousel label',
                      }}
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          value={value}
                          onChange={onChange}
                          placeholder="Primary carousel label"
                          error={() =>
                            errors.mockUserFields?.display?.landing
                              ?.carouselLabelPrimary
                          }
                          errorMsg={
                            errors.mockUserFields?.display?.landing
                              ?.carouselLabelPrimary?.message
                          }
                        />
                      )}
                    />
                  </div>
                  <div className={cs.inputContainer}>
                    <h5>Secondary carousel label</h5>
                    <Controller
                      name="mockUserFields.display.landing.carouselLabelSecondary"
                      rules={{
                        required: 'You must provide a secondary carousel label',
                      }}
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          value={value}
                          onChange={onChange}
                          placeholder="Secondary carousel label"
                          error={() =>
                            errors.mockUserFields?.display?.landing
                              ?.carouselLabelSecondary
                          }
                          errorMsg={
                            errors.mockUserFields?.display?.landing
                              ?.carouselLabelSecondary?.message
                          }
                        />
                      )}
                    />
                  </div>
                  <div className={cs.inputContainer}>
                    <h5>Avatar URL</h5>
                    <Controller
                      name="mockUserFields.display.landing.avatarUrl"
                      rules={{
                        required: 'You must provide an avatar URL label',
                      }}
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          value={value}
                          onChange={onChange}
                          placeholder="Avatar URL"
                          error={() =>
                            errors.mockUserFields?.display?.landing?.avatarUrl
                          }
                          errorMsg={
                            errors.mockUserFields?.display?.landing?.avatarUrl
                              ?.message
                          }
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {watchedMockUserType === MOCK_USER_TYPE.IMPERSONATION && (
            <div className={cs.sectionContainer}>
              <h3>Display</h3>
              <div className={cs.sectionContainer}>
                <h4>Admin</h4>
                <div className={cs.sectionContainer}>
                  <div className={cs.inputContainer}>
                    <h5>Primary card label</h5>
                    <Controller
                      name="mockUserFields.display.admin.cardLabelPrimary"
                      rules={{
                        required: 'You must provide a primary card label',
                      }}
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          value={value}
                          onChange={onChange}
                          placeholder="Primary card label"
                          error={() =>
                            errors.mockUserFields?.display?.admin
                              ?.cardLabelPrimary
                          }
                          errorMsg={
                            errors.mockUserFields?.display?.admin
                              ?.cardLabelPrimary?.message
                          }
                        />
                      )}
                    />
                  </div>
                  <div className={cs.inputContainer}>
                    <h5>Secondary card label</h5>
                    <Controller
                      name="mockUserFields.display.admin.cardLabelSecondary"
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          value={value}
                          onChange={onChange}
                          placeholder="Secondary card label"
                          error={() =>
                            errors.mockUserFields?.display?.admin
                              ?.cardLabelSecondary
                          }
                          errorMsg={
                            errors.mockUserFields?.display?.admin
                              ?.cardLabelSecondary?.message
                          }
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MockUserFields;
